import { RESOURSE_TYPE } from '../../routes/mirroring/constant';

/*
 *
 * 活动列表混排
 * sort //1为顺序，2为倒序
 */
const _concat = function(params) {
  const re = [];
  const _len = params.length;
  if (_len > 0) {
    re = params[0];
    for (const i = 1; i < _len; i++) {
      re = re.concat(params[i]);
    }
  }
  return re;
};
const activity_type = {
  ACTIVITY_SIGNIN: RESOURSE_TYPE.SIGN,
  ACTIVITY_EXERCISE: RESOURSE_TYPE.EXERCISE,
  ACTIVITY_EXERCISE_NEW: RESOURSE_TYPE.NEW_EXAM, // 新版练习
  ACTIVITY_QUESTIONNAIRE: RESOURSE_TYPE.QUESTIONIARE,
  ACTIVITY_ANNOUNCEMENT: RESOURSE_TYPE.ANNOUNCEMENT,
  ACTIVITY_ROLLCALL: RESOURSE_TYPE.ROLLCALL,
  ACTIVITY_DISCUSSION: RESOURSE_TYPE.DISCUSSION,
};
const sortActivity = (_data, sort) => {
  //1为顺序，2为倒序
  //练习
  const _paperList =
    (_data.paperList || []).map(function(value) {
      value.resourceType = activity_type.ACTIVITY_EXERCISE;
      return value;
    }) || [];
  //新版练习
  const _newPaperList =
    (_data.papers || []).map(function(value) {
      value.resourceType = activity_type.ACTIVITY_EXERCISE_NEW;
      value.mocPaper = true;
      return value;
    }) || [];
  //问卷
  const _questionnaireList =
    (_data.questionnaireList || []).map(function(value) {
      value.resourceType = activity_type.ACTIVITY_QUESTIONNAIRE;
      return value;
    }) || [];
  //公告
  const _announceList =
    (_data.announceList || []).map(function(value) {
      value.name = value.title;
      value.resourceType = activity_type.ACTIVITY_ANNOUNCEMENT;
      return value;
    }) || [];
  //签到
  const _signinList =
    (_data.signinList || []).map(function(value) {
      value.name = value.title;
      value.resourceType = activity_type.ACTIVITY_SIGNIN;
      return value;
    }) || [];
  //点名
  const _rollcallList =
    (_data.rollCallList || [])
      .sort(function(a, b) {
        return a.gmtCreate - b.gmtCreate;
      })
      .map(function(value, index) {
        //点名显示名称
        value.rank = index + 1;
        value.resourceType = activity_type.ACTIVITY_ROLLCALL;
        return value;
      }) || [];
  //讨论
  const _postList =
    (_data.postList || [])
      .sort(function(a, b) {
        return a.gmtCreate - b.gmtCreate;
      })
      .map(function(value) {
        value.name = value.title;
        value.resourceType = activity_type.ACTIVITY_DISCUSSION;
        return value;
      }) || [];
  const _activityList = [
    ..._paperList,
    ..._newPaperList,
    ..._questionnaireList,
    ..._announceList,
    ..._signinList,
    ..._rollcallList,
    ..._postList,
  ].sort(function(a, b) {
    if (sort == 1) {
      //备课页按照gmtCreate顺序
      return a.gmtCreate - b.gmtCreate;
    } else {
      //历史记录按照publishTime倒序
      return b.publishTime - a.publishTime;
    }
  });
  return _activityList;
};

export default {
  sortActivity,
};
